/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from "react";

const useUploadFile = <
  TRequest extends { file: File; scope: string; category?: string },
  TResponse
>({
  filters,
  serviceFn,
  onSuccess,
  onError,
}: {
  filters: TRequest;
  serviceFn: (e: TRequest) => Promise<TResponse>;
  onSuccess?: (e: TResponse) => void;
  onError?: (e: any) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const handleUpload = useCallback(
    async (file: File | null, callback?: () => void) => {
      if (!file) return;
      try {
        setLoading(true);
        const payload: TRequest = {
          ...filters,
          file,
        };
        const result = await serviceFn(payload);
        if (typeof callback === "function") {
          callback();
        }
        if (typeof onSuccess === "function") {
          onSuccess({ ...result, file });
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (typeof onError === "function") {
          onError(error);
        }
        // eslint-disable-next-line no-console
        console.error("error", error);
      }
    },
    [filters, onError, onSuccess, serviceFn]
  );

  return {
    loading,
    handleUpload,
  };
};

export default useUploadFile;
